(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["esn-plasma-lp"] && !Shopify.designMode) return;
  try {
    
(function(){
  function initScope(scope){
    if(scope.dataset.epInit)return; scope.dataset.epInit='1';
    scope.classList.add('ep-anim');
    if('IntersectionObserver' in window){
      var io=new IntersectionObserver(function(es){es.forEach(function(e){if(e.isIntersecting){e.target.classList.add('in');io.unobserve(e.target);}});},{threshold:.14,rootMargin:'0px 0px -8% 0px'});
      scope.querySelectorAll('.rv').forEach(function(el){io.observe(el);});
      setTimeout(function(){scope.querySelectorAll('.rv:not(.in)').forEach(function(el){el.classList.add('in');});},3000);
    }else{scope.querySelectorAll('.rv').forEach(function(el){el.classList.add('in');});}
    /* 句読点カーニングの walk（、。 を inline-block span 化）も撤去。inline-block は前後に改行機会を作り禁則(line-break:strict)を無効化して「読点のたびに改行」を生むため（Kent 2026-10-30）。句読点詰めは CSS の font-feature-settings:"palt" で行う。 */
    /* 読点(、。)ごとに文節を inline-block で囲んで強制改行する chunkWalk も撤去済み。文章は禁則処理で自然に折り返し、意図的な改行は Enter / [sp] / [pc] で明示指定する。 */
    /* 孤立行(widont)防止: 各改行(BR)区切りの末尾の短い塊(≤5文字)を nowrap で束ね、折返しで行末が1〜2文字だけにならないようにする（Kentルール「2文字だけの行を作らない」をLP全体で満たす・ビューポート非依存）。ガードは字送り≥1.5pxの英字ラベル(eyebrow)のみスキップ＝字送り境界の隙間「MICROSTRU CTURE」化を防ぐ。見出し(大フォント)も保護対象。 */
    /* 文節ブレーカー: 句読点の後・助詞の後(次が内容語)にゼロ幅スペースを入れ、word-break:keep-allで「その位置だけ」で折り返す。語中で切らず(たわし等を割らない)・毎読点でも切らず、意味の区切りで改行する。溢れはoverflow-wrap:anywhereが保険。 */
    /* 改行(<br>)の直後に残る改行文字・空白を外す。SP専用/PC専用の改行が隠れた時にスペースとして見えるため(例 PCの「最後の一枚が␣ここにある。」) */
    scope.querySelectorAll('br').forEach(function(b){var a=b.nextSibling;if(a&&a.nodeType===3&&/^\s/.test(a.nodeValue))a.nodeValue=a.nodeValue.replace(/^\s+/,'');});
    function muBreak(el){if(el.dataset.epMu)return;el.dataset.epMu='1';el.style.wordBreak='keep-all';el.style.overflowWrap='anywhere';(function f(n){for(var i=0;i<n.childNodes.length;i++){var c=n.childNodes[i];if(c.nodeType===3){var t=c.nodeValue;if(!t.replace(/\s/g,''))continue;var o=t.replace(/([、。，・…！？」』）】〉》])(?=[^\s​、。，・…！？」』）】〉》])/g,'$1​').replace(/((?:から|まで|より|など|ので|のに|でも|には|とは|では|へは|にも|とも|ても|ては|つつ|ながら|こと|もの)|[はがをにへとでものやかねよわ])(?=[一-龠々〆ヵヶァ-ヴー「『（【〈《])/g,'$1​');if(o!==t)c.nodeValue=o;}else if(c.nodeType===1&&c.tagName!=='BR'&&!c.classList.contains('ep-nw')){f(c);}}})(el);}
    scope.querySelectorAll('.ep-lead,.ep-sub,.ep-txt,.ep-fx__text,.ep-fx__subtitle,.ep-evap-body,.ep-evap-detail,.ep-proc-body,.ep-proc-step-b').forEach(muBreak);
    function noWidow(el){if(el.dataset.epNw)return;var _cs=getComputedStyle(el);if(parseFloat(_cs.letterSpacing)>=1.5)return;el.dataset.epNw='1';var segLast=[],cur=null;(function f(n){for(var i=0;i<n.childNodes.length;i++){var c=n.childNodes[i];if(c.nodeType===3){if(c.nodeValue.replace(/\s/g,''))cur=c;}else if(c.nodeType===1){if(c.tagName==='BR'){if(cur){segLast.push(cur);cur=null;}}else if(getComputedStyle(c).display!=='none'&&!c.classList.contains('ep-nw')){f(c);}}}})(el);if(cur)segLast.push(cur);segLast.forEach(function(last){var t=last.nodeValue;var tr=t.replace(/\s+$/,'');var keep=Math.min(5,tr.length);if(tr.length<=keep)return;var head=tr.slice(0,tr.length-keep),tail=tr.slice(tr.length-keep)+t.slice(tr.length);var sp=document.createElement('span');sp.className='ep-nw';sp.style.whiteSpace='nowrap';sp.textContent=tail;last.nodeValue=head;last.parentNode.insertBefore(sp,last.nextSibling);});}
    scope.querySelectorAll('.ep-lead,.ep-sub,.ep-txt,.ep-fx__text,.ep-fx__subtitle,.ep-evap-body,.ep-evap-detail,.ep-proc-body,.ep-proc-step-b').forEach(noWidow);
    /* 約物詰め: 明朝体 Zen Old Mincho はフォントの約物詰め(palt)が効かず「、。」と括弧が全角幅になるため、約物を行内要素(inline)で囲み負の余白で半角相当に詰める(木村 2026-10-31)。10/30に撤去した方式は inline-block で改行位置が増え禁則が崩れたが、inline は改行位置・禁則に影響しない */
    function epKern(root){var w=document.createTreeWalker(root,NodeFilter.SHOW_TEXT,{acceptNode:function(n){var p=n.parentNode;if(!p||/^(SCRIPT|STYLE|TEXTAREA|NOSCRIPT)$/.test(p.nodeName)||(p.classList&&p.classList.contains('ep-pk')))return 2;return /[、。「」『』（）【】]/.test(n.nodeValue)?1:2;}}),ns=[],n;while((n=w.nextNode()))ns.push(n);
      ns.forEach(function(t){var f=document.createDocumentFragment();t.nodeValue.split(/([、。「」『』（）【】])/).forEach(function(x){if(!x)return;var c=x==='。'?'ep-pk ep-pk-m':(/^[、」』）】]$/.test(x)?'ep-pk ep-pk-r':(/^[「『（【]$/.test(x)?'ep-pk ep-pk-l':''));if(c){var sp=document.createElement('span');sp.className=c;sp.textContent=x;f.appendChild(sp);}else f.appendChild(document.createTextNode(x));});t.parentNode.replaceChild(f,t);});}
    epKern(scope);
    /* 文節分割(BudouX・Google製/Apache-2.0・assets/esn-budoux-ja.js): muBreak(読点・助詞の後だけ)は区切りが粗く、SPで行の半分ほどで改行される行が出た(木村 2026-10-31)。muBreakのゼロ幅スペースを外してBudouXの細かい文節区切りに入れ直す。語の途中では割らない。BudouX読込前・失敗時はmuBreakのまま。 */
    function epBx(){if(!window.epBudoux)return;scope.querySelectorAll('[data-ep-mu]').forEach(function(el){if(el.dataset.epBx)return;el.dataset.epBx='1';var w=document.createTreeWalker(el,NodeFilter.SHOW_TEXT),t;while((t=w.nextNode())){if(t.nodeValue.indexOf('\u200b')>-1)t.nodeValue=t.nodeValue.replace(/\u200b/g,'');}try{window.epBudoux.apply(el);}catch(e){}
      /* 禁則: 行頭禁止(、。」』）】＞ 等)の直前と、行末禁止(「『（【＜ 等)の直後の区切り(ゼロ幅スペース)は外す。区切りはブラウザの禁則より優先されて改行できてしまうため */
      var w2=document.createTreeWalker(el,NodeFilter.SHOW_TEXT),t2,all=[];while((t2=w2.nextNode()))all.push(t2);
      all.forEach(function(n,i){var v=n.nodeValue;if(v.indexOf('\u200b')<0)return;var nx=(all[i+1]&&all[i+1].nodeValue.charAt(0))||'',pv=(all[i-1]&&all[i-1].nodeValue.slice(-1))||'';
        var o=v.replace(/\u200b+(?=[、。，．,.」』）】＞〉》］｝！？!?：；・ー…‥ぁぃぅぇぉっゃゅょゎァィゥェォッャュョヮヵヶ々])/g,'').replace(/([「『（【＜〈《［｛])\u200b+/g,'$1');
        if(o.charAt(o.length-1)==='\u200b'&&/^[、。，．,.」』）】＞〉》］｝！？!?：；・ー…‥ぁぃぅぇぉっゃゅょゎァィゥェォッャュョヮヵヶ々]/.test(nx))o=o.replace(/\u200b+$/,'');
        if(o.charAt(0)==='\u200b'&&/[「『（【＜〈《［｛]$/.test(pv))o=o.replace(/^\u200b+/,'');
        if(o!==v)n.nodeValue=o;});
    });}
    /* SP本文のレイアウト(木村 2026-10-31)。PC(768px以上)は従来どおり文節単位(keep-all)。
       1) SPの本文は右端まで詰めて折り返す(語の途中で切れてもよい・独自の改行制御はしない。最後の行の短さはCSSの text-wrap:pretty に任せる)。
       2) 4行以上が続くまとまりは、文の切れ目(「。」の後・改行位置)に空行を入れて3行以内に分ける(木村 2026-10-31「3行改行ルール」=3行まで許容。各まとまりがなるべく3行いっぱいになる位置を選ぶ)。
       文の切れ目の判定用に、文章をBudouXの文節＋読点・句点の後で区切ったspan(ep-ph)に分けておく。 */
    function epFillAll(scope){
      var SP=window.matchMedia('(max-width:767px)').matches;
      /* SPで左揃えの本文・補足・注記(見出し以外・20px以下)は両端揃えにして右端まで揃える。中央揃えの文は対象外 */
      scope.querySelectorAll('.ep-jst').forEach(function(e){e.classList.remove('ep-jst');});
      if(SP)scope.querySelectorAll('p,.ep-fx__text,.ep-txt').forEach(function(e){if(e.closest('h1,h2,h3,h4')||e.offsetParent===null)return;var c=getComputedStyle(e);if(parseFloat(c.fontSize)>20)return;if(/^(left|start|justify)$/.test(c.textAlign))e.classList.add('ep-jst');});
      var rects=function(s){return Array.prototype.filter.call(s.getClientRects(),function(r){return r.width>0;});};
      var shown=function(b){return getComputedStyle(b).display!=='none';};
      scope.querySelectorAll('[data-ep-bx]').forEach(function(el){
        if(/^H[1-6]$/.test(el.tagName))return;
        if(!SP&&!el.dataset.epFill)return;
        var cs=getComputedStyle(el);if(parseFloat(cs.fontSize)>20)return;
        if(!el.dataset.epFill){
          el.dataset.epFill='1';
          el.querySelectorAll('.ep-nw').forEach(function(s){var p=s.parentNode;while(s.firstChild)p.insertBefore(s.firstChild,s);s.remove();});el.normalize();
          var nodes=[],tw=document.createTreeWalker(el,NodeFilter.SHOW_TEXT),t;while((t=tw.nextNode()))nodes.push(t);
          nodes.forEach(function(n){var v=n.nodeValue;if(!v.replace(/[\s\u200b]/g,''))return;var f=document.createDocumentFragment(),ps=v.split('\u200b');
            ps.forEach(function(p,i){if(p){var m=p.match(/^(\s*)([\s\S]*?)(\s*)$/);if(m[1])f.appendChild(document.createTextNode(m[1]));if(m[2])m[2].replace(/([、，。！？])/g,'$1\u0001').split('\u0001').forEach(function(q){if(!q)return;var s=document.createElement('span');s.className='ep-ph';s.textContent=q;f.appendChild(s);});if(m[3])f.appendChild(document.createTextNode(m[3]));}if(i<ps.length-1)f.appendChild(document.createTextNode('\u200b'));});
            n.parentNode.replaceChild(f,n);});
        }
        /* 前回の結果を戻す */
        el.querySelectorAll('.ep-glue').forEach(function(g){var p=g.parentNode;while(g.firstChild)p.insertBefore(g.firstChild,g);g.remove();p.normalize();});
        el.querySelectorAll('br.ep-sbr').forEach(function(b){b.remove();});
        el.querySelectorAll('br.ep-pb').forEach(function(b){b.classList.remove('ep-pb');});
        var tws=[el].concat(Array.prototype.slice.call(el.querySelectorAll('p')));
        if(!SP){tws.forEach(function(x){x.style.wordBreak='keep-all';x.style.textWrap='';});return;}
        tws.forEach(function(x){x.style.wordBreak='normal';x.style.textWrap='';});
        var fs=parseFloat(cs.fontSize);
        /* 2) 空行 */
        var items=[],w=document.createTreeWalker(el,NodeFilter.SHOW_ELEMENT,{acceptNode:function(e){return(e.classList.contains('ep-ph')||e.tagName==='BR')?1:3;}}),e;while((e=w.nextNode()))items.push(e);
        var lineCount=function(a,b){var tops={},n=0;for(var i=a;i<=b;i++){var it=items[i];if(it.tagName==='BR')continue;rects(it).forEach(function(r){var k=Math.round(r.top/4);if(!tops[k]){tops[k]=1;n++;}});}return n;};
        var isCandBr=function(x){return x.tagName==='BR'&&x.classList.contains('ep-brf');};
        var vbr=function(x){return x&&x.tagName==='BR'&&!isCandBr(x)&&shown(x);};
        var enable=function(c){if(c.tagName!=='BR'&&c.parentNode&&c.parentNode.classList&&c.parentNode.classList.contains('ep-pk'))c=c.parentNode;if(c.tagName==='BR'){if(c.classList.contains('ep-brf'))c.classList.add('ep-pb');var x=document.createElement('br');x.className='ep-sbr';c.parentNode.insertBefore(x,c.nextSibling);}else{var b1=document.createElement('br'),b2=document.createElement('br');b1.className=b2.className='ep-sbr';c.parentNode.insertBefore(b2,c.nextSibling);c.parentNode.insertBefore(b1,b2);}};
        var start=0,cand=-1,curP=null;
        for(var i=0;i<items.length;i++){var it=items[i],pp=it.closest('p')||el;
          if(pp!==curP){if(curP!==null){start=i;cand=-1;}curP=pp;}
          if(it.tagName==='BR'){
            if(isCandBr(it)){cand=i;continue;}
            if(!shown(it))continue;
            if(vbr(items[i+1])){start=i+2;cand=-1;i++;continue;}
            cand=i;continue;}
          if(lineCount(start,i)>3&&cand>=start&&cand<i){enable(items[cand]);start=cand+1;cand=-1;}
          var nx=items[i+1];if(/[。！？]$/.test(it.textContent)&&nx&&!vbr(nx)&&!isCandBr(nx))cand=i;
        }
      });
    }
    function epFill(){epFillAll(scope);}
    if(window.epBudoux){epBx();epFill();}else document.addEventListener('ep:budoux',function(){epBx();epFill();});
    if(document.fonts&&document.fonts.ready)document.fonts.ready.then(epFill);
    var epFillW=window.innerWidth,epFillTm;window.addEventListener('resize',function(){if(window.innerWidth===epFillW)return;epFillW=window.innerWidth;clearTimeout(epFillTm);epFillTm=setTimeout(epFill,200);});
    /* SPではPC用の改行(Enter)を流す: SPで左揃えの本文(見出し以外・20px以下)にある単独の<br>に ep-brf を付け、767px以下で非表示。段落の区切り(連続<br>)・[sp]/[pc]・中央揃えの文は残す(木村ルール「SPは左揃えなので改行を入れすぎない」2026-10-31)。 */
    scope.querySelectorAll('[data-ep-mu]').forEach(function(el){var cs=getComputedStyle(el);if(/^H[1-6]$/.test(el.tagName)||parseFloat(cs.fontSize)>20||!/^(left|start|justify)$/.test(cs.textAlign))return;el.querySelectorAll('br:not([class])').forEach(function(b){var p=b.previousSibling,n=b.nextSibling;while(p&&p.nodeType===3&&!p.nodeValue.trim())p=p.previousSibling;while(n&&n.nodeType===3&&!n.nodeValue.trim())n=n.nextSibling;if((p&&p.nodeName==='BR')||(n&&n.nodeName==='BR'))return;b.className='ep-brf';var a=b.nextSibling,z=b.previousSibling;if(a&&a.nodeType===3)a.nodeValue=a.nodeValue.replace(/^\s+/,'');if(z&&z.nodeType===3)z.nodeValue=z.nodeValue.replace(/\s+$/,'');});});
    var oh=scope.querySelector('.ep-hero.ep-out');
    if(oh&&!(window.matchMedia&&window.matchMedia('(prefers-reduced-motion:reduce)').matches)){
      clearTimeout(window.epOutT);
      var os=getComputedStyle(oh),ort=parseFloat(os.getPropertyValue('--out-return'))||0;
      if(!ort&&window.Shopify&&Shopify.designMode)ort=10;
      if(ort){
        var ohide=(parseFloat(os.getPropertyValue('--out-delay'))+parseFloat(os.getPropertyValue('--out-dur'))*(1+(parseFloat(os.getPropertyValue('--out-lag'))||.1)))*1000;
        var ocycle=function(){window.epOutT=setTimeout(function(){oh.classList.remove('ep-out-run');oh.classList.add('ep-out-back');window.epOutT=setTimeout(function(){oh.classList.remove('ep-out-back');void oh.offsetWidth;oh.classList.add('ep-out-run');ocycle();},1200);},ohide+ort*1000);};
        ocycle();
      }
    }
    var fxv=[].slice.call(scope.querySelectorAll('video.ep-fx__vis'));
    if(fxv.length){
      if(window.matchMedia&&window.matchMedia('(prefers-reduced-motion:reduce)').matches){
        fxv.forEach(function(v){v.removeAttribute('autoplay');v.removeAttribute('loop');try{v.pause();}catch(e){}});
      }else if('IntersectionObserver' in window){
        var vio=new IntersectionObserver(function(es){es.forEach(function(e){var v=e.target;if(e.isIntersecting){var p=v.play();if(p&&p.catch){p.catch(function(){});}}else{try{v.pause();}catch(err){}}});},{threshold:.2});
        fxv.forEach(function(v){vio.observe(v);});
      }
    }
    var rvv=[].slice.call(scope.querySelectorAll('video.ep-rev-hoverplay'));
    var rreset=function(v){try{v.pause();if(v.currentTime>0)v.currentTime=0;}catch(e){}};
    var epIsSP=function(){return !!(window.matchMedia&&window.matchMedia('(max-width:768px)').matches);};
    // hoverで1つだけ再生（他は停止）。カーソルを外しても最後にhoverしたものは再生継続
    var rvPlayOnly=function(target){rvv.forEach(function(o){if(o===target){var p=o.play();if(p&&p.catch){p.catch(function(){});}}else{rreset(o);}});};
    rvv.forEach(function(v){
      var card=(v.closest&&v.closest('.ep-rev-card'))||v;
      var pl=function(){var p=v.play();if(p&&p.catch){p.catch(function(){});}};
      card.addEventListener('mouseenter',function(){if(!epIsSP())rvPlayOnly(v);});
      card.addEventListener('click',function(){if(v.paused){pl();}else{rreset(v);}});
      v.addEventListener('play',function(){card.classList.add('ep-rev-playing');});
      v.addEventListener('pause',function(){card.classList.remove('ep-rev-playing');});
      card.classList.add('ep-rev-fx');
    });
    if(rvv.length&&'IntersectionObserver' in window){
      // PC: スクロールアウトで停止・頭出し（hover再生）
      var rrio=new IntersectionObserver(function(es){es.forEach(function(e){if(!e.isIntersecting){var vv=e.target.querySelector('video.ep-rev-hoverplay');if(vv)rreset(vv);}});},{threshold:0});
      rvv.forEach(function(v){var card=(v.closest&&v.closest('.ep-rev-card'))||v;rrio.observe(card);});
      // 初回のみ：先頭が最初に画面へ入った時だけ自動再生。以降は通常のhover/スクロール挙動（止まる）
      var firstCard=(rvv[0].closest&&rvv[0].closest('.ep-rev-card'))||rvv[0];
      var fio=new IntersectionObserver(function(es){es.forEach(function(e){if(e.isIntersecting){var p=rvv[0].play();if(p&&p.catch){p.catch(function(){});}fio.unobserve(e.target);}});},{threshold:.35});
      fio.observe(firstCard);
      // SP: スクロールインで自動再生＋黒からフェード／アウトで停止・頭出し
      if(epIsSP()){
        var spio=new IntersectionObserver(function(es){es.forEach(function(e){var card=e.target,vv=card.querySelector('video.ep-rev-hoverplay');if(!vv)return;if(e.isIntersecting){var p=vv.play();if(p&&p.catch){p.catch(function(){});}}else{rreset(vv);}});},{threshold:.6});
        rvv.forEach(function(v){var card=(v.closest&&v.closest('.ep-rev-card'))||v;spio.observe(card);});
      }
    }
    try{
      var epCorner=scope.querySelector('[data-ep-corner]');
      if(epCorner){
        var cShow=function(){if(window.scrollY>window.innerHeight*0.55)epCorner.classList.add('on');};
        window.addEventListener('scroll',cShow,{passive:true});cShow();
      }
    }catch(e){}
    try{
      var epPopup=scope.querySelector('[data-ep-popup]');
      if(epPopup){
        /* リフレッシュ（ページ読み込み）ごとに、30%スクロールで表示。閉じてもセッションに記録しない。画像は10%で先読みし、表示した瞬間に枠だけにならないようにする(木村 2026-10-31) */
        var pImg=epPopup.querySelector('img'),pPre=false;
        var pShow=function(){var sc=window.scrollY||document.documentElement.scrollTop||0;var h=(document.documentElement.scrollHeight||0)-window.innerHeight;if(!pPre&&pImg&&h>0&&(sc/h)>=0.1){pPre=true;pImg.loading='eager';var pi=new Image();pi.src=pImg.currentSrc||pImg.src;}if(h>0&&(sc/h)>=0.3){epPopup.classList.add('on');epPopup.setAttribute('aria-hidden','false');window.removeEventListener('scroll',pShow);}};window.addEventListener('scroll',pShow,{passive:true});
        var pClose=function(){epPopup.classList.remove('on');epPopup.setAttribute('aria-hidden','true');};
        var pX=epPopup.querySelector('[data-ep-popup-close]');if(pX)pX.addEventListener('click',pClose);
        epPopup.addEventListener('click',function(e){if(e.target===epPopup)pClose();});
      }
    }catch(e){}
    var st=scope.querySelector('[data-ep-sticky]'),ibs=scope.querySelectorAll('.ep-imgbanner'),end=(ibs.length?ibs[ibs.length-1]:null)||scope.querySelector('.ep-footer');
    /* 追従CTAは body 直下の入れ物(.esn-plasma.ep-sticky-host)へ移す。ページ内の親要素の transform/overflow 等に左右されず、画面下に固定させるため */
    if(st&&!st.closest('.ep-sticky-host')){document.querySelectorAll('.ep-sticky-host').forEach(function(h){h.remove();});var sh=document.createElement('div');sh.className='esn-plasma ep-sticky-host';sh.appendChild(st);document.body.appendChild(sh);}
    if(st){function upd(){var show=window.scrollY>window.innerHeight*.9;if(end){var r=end.getBoundingClientRect();if(r.top<window.innerHeight)show=false;}st.classList.toggle('on',show);}window.addEventListener('scroll',upd,{passive:true});upd();}
    if(!(window.matchMedia&&window.matchMedia('(prefers-reduced-motion:reduce)').matches)){
      var bleeds=[].slice.call(scope.querySelectorAll('.ep-bleed'));
      var px=function(){bleeds.forEach(function(b){var r=b.getBoundingClientRect();if(r.bottom<0||r.top>window.innerHeight)return;var prog=(window.innerHeight-r.top)/(window.innerHeight+r.height);var y=50+(prog-0.5)*10;b.style.backgroundPosition='center '+y.toFixed(1)+'%';});};
      window.addEventListener('scroll',px,{passive:true});window.addEventListener('resize',px);px();
    }
    // 検証系タップで全画面拡大（SPの見やすさ・縦スクロール増やさず）
    var zoomables=[].slice.call(scope.querySelectorAll('.ep-evap-fig,.ep-evap-sfig,.ep-evap-lead'));
    if(zoomables.length){
      var ov=document.querySelector('.ep-zoom-ov');
      if(!ov){
        ov=document.createElement('div');ov.className='ep-zoom-ov';ov.setAttribute('aria-hidden','true');
        ov.innerHTML='<button class="ep-zoom-close" type="button" aria-label="閉じる">×</button><div class="ep-zoom-stage"></div>';
        document.body.appendChild(ov);
        var stEl=ov.querySelector('.ep-zoom-stage');
        var closeZoom=function(){ov.classList.remove('on');stEl.innerHTML='';document.documentElement.style.overflow='';};
        ov.addEventListener('click',function(e){if(e.target===ov||e.target.classList.contains('ep-zoom-close'))closeZoom();});
        document.addEventListener('keydown',function(e){if(e.key==='Escape'&&ov.classList.contains('on'))closeZoom();});
      }
      var stage=ov.querySelector('.ep-zoom-stage');
      zoomables.forEach(function(fig){
        if(fig.dataset.epZoom)return; fig.dataset.epZoom='1'; fig.classList.add('ep-zoomable');
        fig.addEventListener('click',function(){
          var media=fig.querySelector('video,img'); if(!media)return;
          stage.innerHTML=''; var node;
          if(media.tagName==='VIDEO'){
            node=document.createElement('video');node.muted=true;node.loop=true;node.autoplay=true;node.playsInline=true;node.setAttribute('playsinline','');
            var src=media.currentSrc||(media.querySelector('source')&&media.querySelector('source').src);
            if(src){node.src=src;} if(media.poster){node.poster=media.poster;}
          }else{
            node=document.createElement('img');node.src=media.currentSrc||media.src;node.alt=media.alt||'';
          }
          node.className='ep-zoom-media';
          stage.appendChild(node);
          ov.classList.add('on');document.documentElement.style.overflow='hidden';
          if(node.tagName==='VIDEO'){var p=node.play();if(p&&p.catch){p.catch(function(){});}}
        });
      });
    }
    // カウントアップ（数値スタット）
    var counters=[].slice.call(scope.querySelectorAll('[data-ep-count]'));
    if(counters.length){
      var fmt=function(n){return Math.round(n).toLocaleString('en-US');};
      var runCount=function(el){
        if(el.dataset.epCounted)return; el.dataset.epCounted='1';
        var target=parseFloat(el.getAttribute('data-ep-count'))||0,dur=1600,t0=null;
        if(window.matchMedia&&window.matchMedia('(prefers-reduced-motion:reduce)').matches){el.textContent=fmt(target);return;}
        function step(ts){if(!t0)t0=ts;var p=Math.min((ts-t0)/dur,1),e=1-Math.pow(1-p,3);el.textContent=fmt(target*e);if(p<1){requestAnimationFrame(step);}else{el.textContent=fmt(target);}}
        requestAnimationFrame(step);
      };
      if('IntersectionObserver' in window){
        var cio=new IntersectionObserver(function(es){es.forEach(function(e){if(e.isIntersecting){runCount(e.target);cio.unobserve(e.target);}});},{threshold:.4});
        counters.forEach(function(el){cio.observe(el);});
      }else{counters.forEach(runCount);}
    }
  }
  function initAll(){document.querySelectorAll('.esn-plasma').forEach(initScope);}
  initAll();
  document.addEventListener('shopify:section:load',initAll);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["recipe"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var REDUCE =
      window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    function initReveal(root) {
      var els = root.querySelectorAll('[data-reveal]:not([data-reveal-init])');
      if (!els.length) return;
      if (REDUCE || !('IntersectionObserver' in window)) {
        els.forEach(function (el) {
          el.setAttribute('data-reveal-init', '');
          el.classList.add('is-in');
        });
        return;
      }
      var io = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              entry.target.classList.add('is-in');
              io.unobserve(entry.target);
            }
          });
        },
        { threshold: 0.12, rootMargin: '0px 0px -8% 0px' }
      );
      els.forEach(function (el) {
        el.setAttribute('data-reveal-init', '');
        io.observe(el);
      });
    }

    function initReels(root) {
      var vids = root.querySelectorAll('[data-reel-video]:not([data-reel-init])');
      if (!vids.length) return;

      var play = function (v) {
        if (REDUCE) return;
        var p = v.play();
        if (p && p.catch) p.catch(function () {});
      };

      var io =
        'IntersectionObserver' in window
          ? new IntersectionObserver(
              function (entries) {
                entries.forEach(function (entry) {
                  if (entry.isIntersecting) play(entry.target);
                  else entry.target.pause();
                });
              },
              { threshold: 0.5 }
            )
          : null;

      vids.forEach(function (v) {
        v.setAttribute('data-reel-init', '');
        if (io) io.observe(v);
        else play(v);

        var btn = v.parentElement.querySelector('[data-reel-sound]');
        if (!btn) return;
        btn.addEventListener('click', function () {
          v.muted = !v.muted;
          btn.classList.toggle('is-on', !v.muted);
          if (!v.muted) {
            var p = v.play();
            if (p && p.catch) p.catch(function () {});
          }
        });
      });
    }

    /* 縦に長くなりすぎる本文を畳む（PC は右カラム・スマホは本文）。半透明フェード＋「続きを見る」で操作を促す。
       短いコンテンツ・JS無効時はそのまま全文表示（プログレッシブエンハンスメント）。
       畳む高さは CSS 変数 --recipe-detail-collapsed が PC/スマホで切り替わる */
    function initDetail(root) {
      var mq = window.matchMedia('(max-width: 999px)');
      var bodies = root.querySelectorAll('.recipe-card__body:not([data-detail-init])');

      bodies.forEach(function (body) {
        var detail = body.querySelector('[data-recipe-detail]');
        var toggle = body.querySelector('[data-recipe-detail-toggle]');
        if (!detail || !toggle) return;
        body.setAttribute('data-detail-init', '');

        var label = toggle.querySelector('.recipe-detail__toggle-label');
        var open = false;

        function collapsedPx() {
          var v = parseInt(getComputedStyle(body).getPropertyValue('--recipe-detail-collapsed'), 10);
          return isNaN(v) ? 300 : v;
        }

        function reset() {
          body.classList.remove('is-collapsible', 'is-open');
          detail.style.maxHeight = '';
          open = false;
          toggle.setAttribute('aria-expanded', 'false');
          if (label) label.textContent = 'レシピの続きを見る';
        }

        // 畳むだけのボリュームがある時だけ is-collapsible を付ける（PC・スマホ共通）。
        // collapsedPx() は CSS 変数の値を返すので、画面幅が 999px を跨ぐと閾値も切り替わる
        function evaluate() {
          var collapsed = collapsedPx();
          if (detail.scrollHeight <= collapsed + 80) { reset(); return; }
          body.classList.add('is-collapsible');
          if (!open) detail.style.maxHeight = collapsed + 'px';
        }

        function expand() {
          open = true;
          body.classList.add('is-open');
          toggle.setAttribute('aria-expanded', 'true');
          if (label) label.textContent = 'とじる';
          if (REDUCE) { detail.style.maxHeight = 'none'; return; }
          // 実寸 px までアニメーションさせ、完了後は none にして以降のリフローを許容
          detail.style.maxHeight = detail.scrollHeight + 'px';
          var done = function (e) {
            if (e.target !== detail || e.propertyName !== 'max-height') return;
            detail.style.maxHeight = 'none';
            detail.removeEventListener('transitionend', done);
          };
          detail.addEventListener('transitionend', done);
        }

        function collapse() {
          open = false;
          toggle.setAttribute('aria-expanded', 'false');
          if (label) label.textContent = 'レシピの続きを見る';
          var collapsed = collapsedPx();
          if (REDUCE) { detail.style.maxHeight = collapsed + 'px'; body.classList.remove('is-open'); return; }
          // none のままだと縮められないので、一度実寸 px に戻してからトランジション
          detail.style.maxHeight = detail.scrollHeight + 'px';
          void detail.offsetHeight; // reflow
          body.classList.remove('is-open');
          detail.style.maxHeight = collapsed + 'px';
          // 畳んだ後に大きな余白へ取り残されないよう、カード先頭へ戻す
          var card = body.closest('.recipe-card');
          if (card && card.getBoundingClientRect().top < 0) {
            card.scrollIntoView({ behavior: REDUCE ? 'auto' : 'smooth', block: 'start' });
          }
        }

        toggle.addEventListener('click', function () {
          if (open) collapse(); else expand();
        });

        var onChange = function () { open = false; evaluate(); };
        if (mq.addEventListener) mq.addEventListener('change', onChange);
        else if (mq.addListener) mq.addListener(onChange);

        evaluate();
      });
    }

    function init(root) {
      root = root || document;
      initReveal(root);
      initReels(root);
      initDetail(root);
    }

    if (document.readyState !== 'loading') init();
    else document.addEventListener('DOMContentLoaded', function () { init(); });

    document.addEventListener('shopify:section:load', function (e) {
      init(e.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["top-atmosphere"] && !Shopify.designMode) return;
  try {
    
(function(){
  function init(root){
    if(root.__esnAtmo) return; root.__esnAtmo = true;
    var reduce = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
    if(!reduce) root.setAttribute('data-esn-play','');
    // ドラッグ（スワイプ）とタップを区別：スワイプ中のクリックでは遷移させない
    var band = root.querySelector('.esn-atmo__band');
    if(band){
      var sx=0, sy=0, moved=false;
      band.addEventListener('pointerdown', function(e){ sx=e.clientX; sy=e.clientY; moved=false; }, { passive:true });
      band.addEventListener('pointermove', function(e){ if(Math.abs(e.clientX-sx)>10 || Math.abs(e.clientY-sy)>10){ moved=true; } }, { passive:true });
      band.addEventListener('click', function(e){ if(moved){ e.preventDefault(); e.stopPropagation(); } }, true);
    }
    var items = root.querySelectorAll('.esn-atmo__reveal');
    if(!('IntersectionObserver' in window) || reduce){
      items.forEach(function(el){ el.classList.add('esn-is-in'); });
      return;
    }
    var io = new IntersectionObserver(function(entries){
      entries.forEach(function(en){ if(en.isIntersecting){ en.target.classList.add('esn-is-in'); io.unobserve(en.target); } });
    }, { threshold:.12, rootMargin:'0px 0px -8% 0px' });
    items.forEach(function(el){ io.observe(el); });
  }
  function boot(){ document.querySelectorAll('[data-esn-atmo]').forEach(init); }
  if(document.readyState !== 'loading') boot();
  else document.addEventListener('DOMContentLoaded', boot);
  document.addEventListener('shopify:section:load', boot);
})();

  } catch(e) { console.error(e); }
})();
})();
